'use strict';

var _classCallCheck = require("/codebuild/output/src977441055/src/ibrd/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/codebuild/output/src977441055/src/ibrd/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/codebuild/output/src977441055/src/ibrd/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/codebuild/output/src977441055/src/ibrd/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/codebuild/output/src977441055/src/ibrd/node_modules/@babel/runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.charLength = charLength;
exports.createEncoding = createEncoding;

var CharsetLengthError =
/*#__PURE__*/
function (_Error) {
  _inherits(CharsetLengthError, _Error);

  function CharsetLengthError(length) {
    _classCallCheck(this, CharsetLengthError);

    return _possibleConstructorReturn(this, _getPrototypeOf(CharsetLengthError).call(this, "Charset needs to contain exactly 2^n characters. ".concat(length, " is not a power of 2.")));
  }

  return CharsetLengthError;
}(_wrapNativeSuper(Error));

exports.CharsetLengthError = CharsetLengthError;

function charLength(charset) {
  if (!charset || !charset.length) {
    throw new CharsetLengthError(0);
  }

  var charsetLength = charset.length.toString(2);
  var powerOf2 = charsetLength.length > 1 && charsetLength.match(/1/g).length === 1;

  if (!powerOf2) {
    throw new CharsetLengthError(charset.length);
  }

  return charsetLength.length - 1;
}

function createEncoding(charset) {
  var _charLength = charLength(charset);

  var encodeBaseN = function encodeBaseN(bytes) {
    var numBits = bytes.length * 8;
    var hashLength = Math.ceil(numBits / _charLength);
    var output = new Array(hashLength);
    var pos = 0;
    var charNum = 0;

    while (pos < numBits) {
      var chunk = 0;

      for (var i = 0; i < _charLength; i++) {
        var _pos = pos + i;

        var byte = bytes[_pos >> 3]; // _pos % 8

        _pos = _pos & 7; // Math.floor(_pos / 8);

        var bit = byte >> 7 - _pos & 1;
        chunk <<= 1;
        chunk |= bit;
      }

      output[charNum] = charset[chunk];
      pos += _charLength;
      charNum++;
    }

    return output;
  };

  Object.defineProperty(encodeBaseN, 'name', {
    value: 'encodeBase' + charset.length,
    configurable: true
  });
  return encodeBaseN;
}